const Button = (props) => {
  return (
    <button className={`button-big ${props.cssClass}`} disabled={props.disabled} >{props.text}</button>
  );
};

export default Button;
